import { IdpTokens } from './provider';

/**
 * Os tokens do IDP, **so em memoria**.
 *
 * Modulo singleton e nao estado de React de proposito: quem mais precisa ler o
 * access token e o interceptor do axios (`services/request.ts`), que nao e
 * componente e nao pode depender de contexto. A alternativa — guardar em
 * `localStorage` como a sessao legada — e exatamente o que o contrato do IDP
 * proibe (`seazone-idp/docs/integracao/proibicoes.md`, item 1).
 *
 * O preco e explicito: recarregar a pagina apaga isto. Quem devolve a sessao e
 * o re-login silencioso contra a sessao SSO do IDP, nunca uma copia em disco.
 */

type Listener = (tokens: IdpTokens | undefined) => void;

let current: IdpTokens | undefined;
const listeners = new Set<Listener>();

export function getIdpTokens(): IdpTokens | undefined {
  return current;
}

export function setIdpTokens(tokens: IdpTokens | undefined): void {
  current = tokens;
  listeners.forEach((listener) => listener(current));
}

export function clearIdpTokens(): void {
  setIdpTokens(undefined);
}

export function subscribeIdpTokens(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * O access token que o interceptor deve mandar, ou `undefined` quando a sessao
 * ativa nao e do IDP.
 */
export function getIdpAccessToken(): string | undefined {
  return current?.accessToken;
}
